import React from "react";
import "./PicturesAndVideosSlider.scss";
import DataNotFound from "component/shared/DataNotFound/DataNotFound";
import { END_POINTS } from "constants/APIConstant";
import useSWR from "swr";
import ContentLoading from "component/LoadingComponent/ContentLoading";
import { DateFormater } from "functions/dateTimeFormat";
import { API_BASE_URL } from "configs/AppConfig";
import AOS from 'aos';
import 'aos/dist/aos.css'
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import LabelLang from "component/LabelLang/label-lang";

function PicturesAndVideosSlider() {

  React.useEffect(() => {   
    AOS.init();
    AOS.refresh();
  }, [])


  const photoAlbum = useSWR({
    url: `${END_POINTS.PINNED_PHOTOS}`,
  });


  const myList = [
    {
      imgSlide: process.env.PUBLIC_URL + "/image/mediaLandingNews.png",
      title: `اجتماع السيد رئيس الجهاز مع السيدة الينا بانوفا الممثل المقيم
      للأمم المتحدة بمصر`,
      date: 'أكتوبـر 2022'
    },
    {
      imgSlide: process.env.PUBLIC_URL + "/image/news1.png",
      title: `اجتماع السيد رئيس الجهاز مع السيدة الينا بانوفا الممثل المقيم
      للأمم المتحدة بمصر`,
      date: 'أكتوبـر 2022'
    },
    {
      imgSlide: process.env.PUBLIC_URL + "/image/newsr2.png",
      title: `اجتماع السيد رئيس الجهاز مع السيدة الينا بانوفا الممثل المقيم
      للأمم المتحدة بمصر`,
      date: 'أكتوبـر 2022'
    },
    {
      imgSlide: process.env.PUBLIC_URL + "/image/news2.png",
      title: `اجتماع السيد رئيس الجهاز مع السيدة الينا بانوفا الممثل المقيم
      للأمم المتحدة بمصر`,
      date: 'أكتوبـر 2022'
    },
    {
      imgSlide: process.env.PUBLIC_URL + "/image/newsr2.png",
      title: `اجتماع السيد رئيس الجهاز مع السيدة الينا بانوفا الممثل المقيم
      للأمم المتحدة بمصر`,
      date: 'أكتوبـر 2022'
    },
    {
      imgSlide: process.env.PUBLIC_URL + "/image/newsr3.png",
      title: `اجتماع السيد رئيس الجهاز مع السيدة الينا بانوفا الممثل المقيم
      للأمم المتحدة بمصر`,
      date: 'أكتوبـر 2022'
    },
    {
      imgSlide: process.env.PUBLIC_URL + "/image/flags.png",
      title: `اجتماع السيد رئيس الجهاز مع السيدة الينا بانوفا الممثل المقيم
      للأمم المتحدة بمصر`,
      date: 'أكتوبـر 2022'
    },
    {
      imgSlide: process.env.PUBLIC_URL + "/image/tv.png",
      title: `اجتماع السيد رئيس الجهاز مع السيدة الينا بانوفا الممثل المقيم
      للأمم المتحدة بمصر`,
      date: 'أكتوبـر 2022'
    },
    {
      imgSlide: process.env.PUBLIC_URL + "/image/newsr2.png",
      title: `اجتماع السيد رئيس الجهاز مع السيدة الينا بانوفا الممثل المقيم
      للأمم المتحدة بمصر`,
      date: 'أكتوبـر 2022'
    },
  ]


  const renderPhotoAlbum = () => {
    const photoos =
      photoAlbum.error ||
      photoAlbum.isLoading ||
      photoAlbum.data === undefined ||
      photoAlbum.data === null
        ? []
        : photoAlbum.data.data;

    const rendering = photoos.map(
      ({ thumbnail, publishingDate, photoAlbum }, i) =>
        Object.keys(photoos).length > 0 ? (
          <div key={i} className="item-sd">
            <img
              className="img1"
              src={
                thumbnail ? `${API_BASE_URL}/${thumbnail}` : myList[0].imgSlide
              }
              alt="swiper-img"
              loading="lazy"
            />
            <h5>
              <LabelLang
                id="title"
                defaultValue={photoAlbum?.title}
                translations={photoAlbum?.photoAlbumTranslations}
              />
            </h5>
            <h6>
              <DateFormater value={publishingDate} type={"monthYear"} />
            </h6>
          </div>
        ) : (
          <DataNotFound />
        )
    );

    return rendering;
  }


  const options = {
    loop: true,
    center: true,
    margin: 30,
    responsiveClass: true,
    autoplay: true,
    dots: false,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    smartSpeed: 500,
    nav: true,
    dir: 'ltr',
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      768: {
        items: 3,
      },
      992: {
        items: 3,
      },
      1200: {
        items: 5,
      }
    }
  }


  return (
    <ContentLoading 
      isLoading={
        photoAlbum.isLoading
      }
    >
      <div className="PicturesAndVideosSlider" data-aos='fade-down' data-aos-duration="1000" data-aos-easing="ease-in-sine">
        {Object.keys(renderPhotoAlbum()).length > 0 ?
          <OwlCarousel id="photoAlbum-testimonoals" className='owl-theme' {...options}>
            {renderPhotoAlbum()}
          </OwlCarousel>
          :
          <DataNotFound />
        }
      </div>
    </ContentLoading>
  );
}

export default PicturesAndVideosSlider;
